var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text",style:(_vm.colorDiv()),on:{"mousemove":_vm.mouseOver,"mouseleave":_vm.mouseLeave}},[_c('div',{staticClass:"overlay"}),_c('div',{staticClass:"p1"},[_c('p',[_vm._v(_vm._s(_vm.item.p1))])]),_c('div',{staticClass:"span"},[_c('span',[_vm._v(_vm._s(_vm.item.span))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }